import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const boardsDirectoryRoute: InvariantJiraRoute = {
	name: 'boards-directory',
	path: '/jira/boards',
};
